'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'diamond';
var width = 576;
var height = 512;
var aliases = [9830];
var unicode = 'f219';
var svgPathData = 'M38.6 278.6L16 256 38.6 233.4 265.4 6.6 288-16 310.6 6.6 537.4 233.4 560 256 288 528 265.4 505.4 38.6 278.6zM61.3 256L288 482.7 514.7 256 288 29.3 61.3 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamond = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;